/**
 * Team page: values slider (Swiper, autoplay 4s, arrows + dots).
 */
(function () {
	'use strict';

	if (typeof Swiper === 'undefined') {
		return;
	}

	var roots = document.querySelectorAll('[data-team-values-slider]');
	if (!roots.length) {
		return;
	}

	var reduceMotion =
		typeof window.matchMedia === 'function' &&
		window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	roots.forEach(function (root) {
		var el = root.querySelector('.page-team__values-swiper');
		if (!el) {
			return;
		}

		var slides = el.querySelectorAll('.swiper-slide');
		var count = slides.length;
		if (!count) {
			return;
		}

		var prevBtn = root.querySelector('[data-team-values-prev]');
		var nextBtn = root.querySelector('[data-team-values-next]');
		var paginationEl = root.querySelector('[data-team-values-pagination]');

		var enableNav = count > 1 && prevBtn && nextBtn && paginationEl;

		new Swiper(el, {
			slidesPerView: 1,
			effect: count > 1 ? 'fade' : 'slide',
			fadeEffect: { crossFade: true },
			speed: 600,
			loop: count > 1,
			grabCursor: count > 1,
			autoplay:
				reduceMotion || count <= 1
					? false
					: {
							delay: 4000,
							disableOnInteraction: false,
					  },
			navigation: enableNav
				? {
						prevEl: prevBtn,
						nextEl: nextBtn,
				  }
				: undefined,
			pagination: enableNav
				? {
						el: paginationEl,
						clickable: true,
				  }
				: undefined,
		});
	});
})();
